// src/api/aiChatService.ts
import axios from 'axios';
import { store } from '../app/store';

export interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    timestamp: string;
    details?: ChatResponseDetails;
}

export interface ChatRequestPayload {
    session_id: string;
    question: string;
    chat_room_id: string;
    document_id: string;
    search_k: number;
    include_sources: boolean;
    max_iterations: number;
    model?: string;
}

export interface ToolCall {
    tool_name: string;
    tool_input: any;
    tool_output: any;
    success: boolean;
    error: string | null;
}

export interface Step {
    step_number: number;
    node_name: string;
    action: string;
    description: string;
    tool_calls: ToolCall[] | null;
    timestamp: string;
}

export interface Source {
    document_id: string;
    index: number;
    category: string;
    content: string;
    similarity_score: number;
}

export interface ChatResponseDetails {
    reasoning: string;
    steps: Step[];
    tools_used: string[];
    sources: Source[];
    api_calls: any;
    model: string;
    processing_time_ms: number;
    iterations: number;
}

export interface ChatResponse {
    success: boolean;
    session_id: string;
    question: string;
    answer: string;
    reasoning: string;
    steps: Step[];
    tools_used: string[];
    sources: Source[];
    api_calls: any;
    model: string;
    processing_time_ms: number;
    iterations: number;
    timestamp: string;
}

const AI_API_BASE_URL = 'https://ai.laiatools.com';

/**
 * Sends a chat message to the AI agent and returns the response
 */
export const sendChatMessage = async (payload: ChatRequestPayload): Promise<ChatResponse> => {
    const token = store.getState().auth.token;
    
    const response = await axios.post(
        `${AI_API_BASE_URL}/v1/langgraph-agent/chat`,
        payload,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        }
    );

    return response.data;
};


